import React, { useState } from "react";
import { useSelector } from "react-redux";
import AssessmentModal from "../Components/AssessmentModal";
import CourseSlider from "../Components/Courses/CourseSlider";
import LoadingCom from "../Components/LoadingCom";
import { ClockIcon, LocationIcon } from "../utils/icons";
import { Badge, Col, Row } from "antd";
import cognitiveImg from "../assets/assessment/cognitive_Assessment.jpg";
import CorporateImg from "../assets/assessment/Corporate_Communication_Assessment.jpg";
import DigitalImg from "../assets/assessment/Digital_Readiness_Assessment.jpg";
import EmotionalImg from "../assets/assessment/Emotional_Intelligence_Assessment.jpg";
import LeadershipImg from "../assets/assessment/Leadership_Assessment.jpg";
import LearningImg from "../assets/assessment/Learning_Agility_Assessment.jpg";
import PersonalityImg from "../assets/assessment/Personality_Assessment.jpg";
import { LoadingOutlined } from "@ant-design/icons";
import assessmentCover from "../assets/images/assessmentCover.png";
import audioImage from "../assets/images/audioImage.svg";
import CommunicationImage from "../assets/images/CommunicationImage.svg";
import ProblemImage from "../assets/images/ProblemImage.svg";
import socialSkillImage from "../assets/images/socialSkillImage.svg";

function AssessmentTab({ ids }) {
  console.log("🚀 ~ AssessmentTab ~ ids:", ids);
  const assessmentData = useSelector((state) => state.coursera.assessmentData);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleBoxClick = (course) => {
    setSelectedCourse(course); // Update state with data of the clicked box
    setIsModalOpen(true); // Open the modal
  };

  const imagesArray = [
    audioImage,
    CommunicationImage,
    ProblemImage,
    socialSkillImage,
  ];

  return (
    <div className="mb-10">
      {/* <CourseSlider count={10} title="Assessments" assessment={true}> */}
      <Row gutter={[10, 10]}>
        {assessmentData?.length ? (
          assessmentData?.map((course, items) => (
            <Col
              // xl={6}
              lg={8}
              md={12}
              onClick={() => handleBoxClick(course)}
              key={course.id}
              className="cursor-pointer"
              // onClick={
              //   () => setIsModalOpen(true)
              //   // navigate(`/courses/${course.id}`, {
              //   //   state: { data: course },
              //   // })
              // }
            >
              <div className="bg-pureWhite rounded-xl p-3 h-full">
                <Badge.Ribbon
                  text={
                    // ids.length ? (
                    ids.includes(course.id) ? "Attempted" : "Not Attempted"
                    // )
                    // : (
                    //   <LoadingOutlined />
                    // )
                  }
                  color={
                    // ids.length
                    //   ?
                    ids.includes(course.id) ? "green" : "red"
                    // : ""
                  }
                />
                {/* <img
                  className="rounded-lg w-full"
                  src={
                    course?.name === "Cognitive Assessment"
                      ? cognitiveImg
                      : course?.name ===
                        "Corporate Communication Skills Assessment"
                      ? CorporateImg
                      : course?.name === "Digital Readiness Assessment"
                      ? DigitalImg
                      : course.name === "Emotional Intelligence Assessment"
                      ? EmotionalImg
                      : course.name === "Leadership Assessment"
                      ? LeadershipImg
                      : course.name === "Learning Agility Assessment"
                      ? LearningImg
                      : course.name === "Personality Assessment"
                      ? PersonalityImg
                      : assessmentCover
                  }
                  // src="https://www.unityoga.org/uploads/2/5/7/4/25747040/research-assessment-evaluation-fb_orig.jpg"
                  alt={course?.name}
                  width={241}
                  height={140}
                /> */}
                <div className="h-[150px] bg-[#FA7B2C] rounded-xl flex items-center pl-5 hover:shadow-none shadow-test">
                  <img
                    src={imagesArray[items]}
                    className="transform transition-all duration-1000 ease-in-out hover:h-28 hover:scale-110 hover:translate-x-5"
                    alt={imagesArray[items]}
                  />
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="text-base text-black font-semibold">
                    {course?.name}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {/* {course?.updatedAt} */}
                    {course.duration + "min"}
                  </p>
                </div>
                <div className="flex justify-between items-center mt-2">
                  {/* <p className="text-sm text-black font-medium">
                {course?.defaultInstructions}
              </p> */}
                  <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                    <span>
                      <ClockIcon />
                    </span>
                    {/* <span>{course?.duration}</span> */}
                    <span>{course.createdAt}</span>
                  </p>
                </div>
                <div className="flex justify-between items-center mt-2 mx-1">
                  <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                    <span>
                      <LocationIcon />
                    </span>
                    {/* <span>{course?.location}</span> */}
                    <span>{course?.assessmentType}</span>
                  </p>
                  <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                    Max Marks {course?.maxMarks}
                  </p>
                </div>
              </div>
            </Col>
          ))
        ) : (
          <div className="w-full">
            <LoadingCom />
          </div>
        )}
      </Row>

      {/* </CourseSlider> */}
      <AssessmentModal
        data={selectedCourse}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
      />
    </div>
  );
}

export default AssessmentTab;
